<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <strong class="name-account">{{ currentUserBind.account }}</strong>
      <img
        v-if="showAccount"
        :src="
          currentUserBind.infoAccount.anh_dai_dien
            ? currentUserBind.infoAccount.anh_dai_dien
            : 'img/user.png'
        "
        class="img-avatar"
        width="40"
        style="object-fit: cover; object-position: center"
      />
    </template>
    <template slot="dropdown">
      <b-card
        :no-body="true"
        footer-class="px-3 py-2"
        class="mb-0 header-card-account"
      >
        <b-card-body class="p-3 clearfix">
          <!-- <i class="icon-user bg-primary p-3 font-2xl mr-3 float-left"></i> -->
          <div class="mr-3 float-left">
            <img
              :src="
                currentUserBind.infoAccount.anh_dai_dien
                  ? currentUserBind.infoAccount.anh_dai_dien
                  : 'img/user.png'
              "
              class="img-avatar"
              width="50"
              style="object-fit: cover; object-position: center; height: 50px"
            />
          </div>
          <div></div>
          <div class="h6 text-info mb-0 mt-2 mb-1">
            {{ currentUserBind.infoAccount.name }}
          </div>
          <!-- <div class="font-xs text-muted text-uppercase bold-500">
            {{ currentUserBind.infoAccount.position }}
          </div> -->
        </b-card-body>
        <!-- <div slot="footer">
          <b-link
            class="font-weight-bold font-xs btn-block text-muted"
            @click="fn_gottoInFoAccount()"
          >
            Chi tiết thông tin cá nhân
            <i class="fa fa-angle-right float-right font-lg"></i>
          </b-link>
        </div>-->
      </b-card>
      <!-- <b-dropdown-header tag="div" class="text-center">
        <strong>{{currentUserBind.infoAccount.name}} - {{currentUserBind.infoAccount.position}}</strong>
      </b-dropdown-header>-->

      <!-- Hiển thị thông báo -->
      <!-- <b-dropdown-item>
        <i class="fa fa-bell-o" /> Thông báo
        <b-badge variant="info">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-envelope-o" /> Tin nhắn
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-tasks" /> Công việc
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>-->

      <!-- <b-dropdown-item><i class="fa fa-comments" /> Comments
        <b-badge variant="warning">{{ itemsCount }}</b-badge>
      </b-dropdown-item>-->
      <!-- <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-usd" /> Payments
        <b-badge variant="secondary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-file" /> Projects
        <b-badge variant="primary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>-->
      <!-- <b-dropdown-divider /> -->
      <!-- <b-dropdown-item>
        <i class="fa fa-shield" /> Lock Account
      </b-dropdown-item>-->
      <b-dropdown-item router-link to="/auth/changepassword">
        <i class="icon-key" />
        {{ aLang.header_goChangePassword }}
      </b-dropdown-item>
      <b-dropdown-item @click="fn_logout()">
        <i class="icon-logout" />
        {{ aLang.logout }}
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";

import AuthService from "../service/AuthService";
import LanguageService from "../service/LanguageService";
import MethodService from "../service/MethodService";
import ExtensionService from "../service/ExtensionService";
import Hssk831Api from "../moduleApi/Hssk831Api";
import KhaoSatApi from "../moduleApi/KhaoSatApi";
import COSApi from "../moduleApi/COSApi";
import NguoiDanApi from "../moduleApi/NguoiDanApi";
import EhrApi from "../moduleApi/EhrApi";

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
  },
  data: () => {
    return {
      aLang: LanguageService.lang,
      itemsCount: 0,
      currentUser: {},
      currentUserBind: {
        account: "",
        infoAccount: {},
      },
      showAccount: false,
    };
  },
  methods: {
    fn_logout() {
      this.$confirm(LanguageService.lang.logout, {
        confirmButtonText: LanguageService.lang.c_yes,
        cancelButtonText: LanguageService.lang.c_no,
        type: "info",
        maxWidth: "90vw",
      })
        .then(() => {
          AuthService.logout(false)
            .then((res) => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_success,
                type: "success",
              });
              window.localStorage.removeItem("routerHistory");
              window.localStorage.removeItem("token");
              window.localStorage.removeItem("account");
              window.localStorage.removeItem("dataUser");
              window.localStorage.removeItem("cardcode");
              window.localStorage.removeItem("currentUser");
              window.sessionStorage.removeItem("steps");
              window.sessionStorage.removeItem("lastBooking");
              window.localStorage.removeItem("dataLocalHealthRecord");
              window.localStorage.removeItem("isDoctorTram");
              window.localStorage.removeItem("currentUserBS");
              this.$router.push("/auth/login");
            })
            .catch((error) => {
              this.$store.commit("fn_saveDataUser", {});
              this.$message({
                showClose: true,
                message: this.aLang.logout_error,
                type: "error",
              });
            });
        })
        .catch();
    },

    fn_setRole() {
      if (this.currentUser.roles.indexOf("BuiltinAdmin") != -1) {
        this.currentUser.infoAccount.position = "Quản trị hệ thống";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Super admin";
      }
      if (this.currentUser.roles.indexOf("Admin") != -1) {
        this.currentUser.infoAccount.position = "Quản trị hệ thống";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Admin";
      }
      if (this.currentUser.roles.indexOf("Doctor_His") != -1) {
        this.currentUser.infoAccount.position = "Bác sỹ";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Doctor";
      }
      if (this.currentUser.roles.indexOf("Hospital") != -1) {
        this.currentUser.infoAccount.position = "Bệnh viện";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Hospital";
      }
      if (this.currentUser.roles.indexOf("Citizen") != -1) {
        this.currentUser.infoAccount.position = "Bệnh nhân";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Citizen";
      }
      if (this.currentUser.account == "tichhop") {
        this.currentUser.infoAccount.position = this.currentUser.infoAccount
          .position
          ? this.currentUser.infoAccount.position
          : "Bác sỹ trạm";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Doctor";
      }
      this.currentUserBind = this.currentUser;
    },

    async fn_getAccount() {
      if (window.location.href.includes("hssk4210")) {
        let currentUser = localStorage.getItem("currentUser");
        if (!currentUser) {
          this.showAccount = false;
          return;
        }
      }
      this.showAccount = true;
      this.currentUser = MethodService.getCurrentUser();
      this.currentUser.infoAccount = {
        email: "",
        name: "",
        phoneNumber: "",
        position: "",
      };
      // console.log("Thông tin người dùng");
      // console.log(this.currentUser);
      if (this.currentUser.account == "tichhop") {
        let currentUserBS = MethodService.getCurrentUserBS();
        this.currentUser.infoAccount.email = currentUserBS.EMailCSKCB;
        this.currentUser.infoAccount.name = currentUserBS.TenCSKCB;
        this.currentUser.infoAccount.phoneNumber =
          currentUserBS.SoDienThoaiCSKCB;
        this.currentUser.infoAccount.position = currentUserBS.DiaChiCSKCB;
        this.currentUser.account = currentUserBS.BranchCode;
      } else if (this.currentUser.account == "admin") {
        this.currentUser.infoAccount.name = "Admin";
        this.currentUser.account = "Admin";
      } else {
        let cardcode = window.localStorage.getItem("account");
        let dataUser = JSON.parse(window.localStorage.getItem("dataUser"));
        if (dataUser && dataUser.FullName) {
          this.currentUser.infoAccount.name = dataUser.FullName
            ? dataUser.FullName
            : "";
          this.currentUser.infoAccount.anh_dai_dien = dataUser.AvatarUrl
            ? window.MyConfig.imageUrl + dataUser.AvatarUrl
            : null;
          this.currentUser.account = dataUser.FullName ? dataUser.FullName : "";
        } else {
          if (cardcode) {
            let response = await COSApi.GetInfoUser(cardcode);
            if (response.data && response.data.Data && response.data.Data[0]) {
              this.currentUser.infoAccount.name = response.data.Data[0].FullName
                ? response.data.Data[0].FullName
                : "";
              if (response.data.Data[0].AvatarUrl) {
                let find = "\\\\";
                let re = new RegExp(find, "g");
                response.data.Data[0].AvatarUrl =
                  response.data.Data[0].AvatarUrl.replace(re, "/");
                this.currentUser.infoAccount.anh_dai_dien =
                  window.MyConfig.imageUrl + response.data.Data[0].AvatarUrl;
              }
              if (response.data.Data[0].CmndBeforeUrl) {
                let find = "\\\\";
                let re = new RegExp(find, "g");
                response.data.Data[0].CmndBeforeUrl =
                  response.data.Data[0].CmndBeforeUrl.replace(re, "/");
              }
              if (response.data.Data[0].CmndAfterUrl) {
                let find = "\\\\";
                let re = new RegExp(find, "g");
                response.data.Data[0].CmndAfterUrl =
                  response.data.Data[0].CmndAfterUrl.replace(re, "/");
              }
              window.localStorage.setItem(
                "dataUser",
                JSON.stringify(response.data.Data[0])
              );
              this.currentUserBind.account = response.data.Data[0].FullName
                ? response.data.Data[0].FullName
                : "";
            }
          } else {
            if (this.currentUser.id) {
              let data = await NguoiDanApi.findById({
                id: this.currentUser.id,
              });
              this.currentUser.infoAccount.name =
                data.result.ho_ten && data.result.ho_ten.ho_ten
                  ? data.result.ho_ten.ho_ten
                  : "";
            }
            if (this.currentUser.account) {
              let avatar = await EhrApi.GetEhrDoctor(this.currentUser.account);
              if (
                avatar.data.Success &&
                avatar.data.Data &&
                avatar.data.Data.length > 0 &&
                avatar.data.Data[0].AVATAR_URL
              ) {
                this.currentUser.infoAccount.anh_dai_dien =
                  window.MyConfig.imageUrl + avatar.data.Data[0].AVATAR_URL;
              }
            }
          }
        }
      }
      this.fn_setRole();
    },

    fn_gottoInFoAccount() {
      this.$router.push({
        name: "Admin-NguoiDung-update",
        params: { id: this.currentUserBind.id },
      });
    },
  },
  created() {
    this.fn_getAccount();
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .name-account {
    display: none;
  }
}
</style>
